import { render, staticRenderFns } from "./AdvPortForwardingShow.vue?vue&type=template&id=9686d428&"
import script from "./AdvPortForwardingShow.vue?vue&type=script&lang=js&"
export * from "./AdvPortForwardingShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports